import { render, staticRenderFns } from "./index.vue?vue&type=template&id=75a01025&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a01025",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75a01025')) {
      api.createRecord('75a01025', component.options)
    } else {
      api.reload('75a01025', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=75a01025&scoped=true", function () {
      api.rerender('75a01025', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/packages/BjInputNumber/index.vue"
export default component.exports